import { State } from "./State";
export class Room {
    constructor(eventsChannelFactory, id, enabled, integratedDisplay, pictureId, name, state, gallery, roomRewards, offline) {
        this.eventsChannelFactory = eventsChannelFactory;
        this.id = id;
        this.roomRewards = roomRewards;
        this.enabled = new State(enabled);
        this.integratedDisplay = new State(integratedDisplay);
        this.pictureId = new State(pictureId);
        this.name = new State(name);
        this.state = new State(state);
        this.gallery = new State(gallery);
        this.offline = new State(offline);
    }
    getEventsChannel() {
        return this.eventsChannelFactory.createEventsChannel(`room.${this.id}`);
    }
}
